import { render, staticRenderFns } from "./maternity.vue?vue&type=template&id=80827d3a&"
import script from "./maternity.vue?vue&type=script&lang=js&"
export * from "./maternity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports